export default __webpack_public_path__ + "static/media/electronics.20b980f0.jpg";